import React from "react";
import { SlidersHorizontal, Cog } from "lucide-react";

export default function PreferencesTab() {
  return (
    <div className="p-fluid-5 flex flex-col items-center justify-center text-center h-full">

      {/* Main Icon with Glow */}
      <div className="relative mb-fluid-3">
        {/* Glow ring */}
        <div className="absolute inset-0 bg-[#223688]/20 dark:bg-[#31C4AB]/20 blur-2xl rounded-full" />

        {/* Icon */}
        <div className="relative flex items-center justify-center w-[5rem] h-[5rem] rounded-full 
                        bg-[#223688]/10 dark:bg-[#31C4AB]/10 border border-gray-300 dark:border-acs-dark-border">
          <SlidersHorizontal className="w-10 h-10 text-[#223688] dark:text-[#31C4AB]" />
        </div>
      </div>

      {/* Title */}
      <h2 className="text-fluid-xl font-semibold text-gray-900 dark:text-white mb-fluid-1">
        Preferences Coming Soon
      </h2>

      {/* Subtitle */}
      <p className="text-fluid-base text-gray-600 dark:text-acs-dark-subtext max-w-[32rem] mb-fluid-3">
        You will soon be able to customize your experience with theme options,
        notification preferences, layout controls, and more.
      </p>

      {/* Status Banner */}
      <div className="
        flex items-center gap-fluid-2 
        bg-blue-100 dark:bg-blue-500/20 
        text-blue-800 dark:text-blue-300 
        px-fluid-4 py-fluid-2 
        rounded-lg border border-blue-300/50 dark:border-blue-500/40
      ">
        <Cog className="w-fluid-icon-sm h-fluid-icon-sm animate-spin-slow" />
        <span className="text-fluid-sm font-medium">
          Personalization in progress...
        </span>
      </div>

    </div>
  );
}
